module.exports = __webpack_public_path__ + "img/border_rectangle4.a01cc22c.svg";